<form [formGroup]="form">
  <div class="crud-item-section">
  
    <span>
      <mat-form-field matTooltip="Select a Maintenance Type from the list" [matTooltipDisabled]="disabledTooltip(this.maintenanceType)">
        <mat-label i18n="@@type.MaintenanceAspect.maintenanceType">Maintenance Type</mat-label>
        <mat-select formControlName="maintenanceType" id="maintenanceType"              
            (ngModelChange)="maintenanceTypeChanging($event)" [(ngModel)]="item.maintenanceType"              
            (ngModelChange)="maintenanceTypeChanged($event)" #maintenanceType              
            placeholder="Maintenance Type">
          <mat-option>Any</mat-option>
          <mat-option *ngFor="let maintenanceType of maintenanceTypeSelectionList" [value]="maintenanceType.code">
            {{maintenanceType.code}} ({{maintenanceType.meaning}})
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>

    <span>
      <span>
        <mat-slide-toggle floatLabel="always" appearance="none" color="primary"
            formControlName="visualInspection" id="visualInspection" matToolTip="Should visual inspection occur prior to use?"              
            (ngModelChange)="visualInspectionChanging($event)" [(ngModel)]="item.visualInspection"              
            (ngModelChange)="visualInspectionChanged($event)" #visualInspection i18n="@@type.MaintenanceAspect.visualInspection">
Visual Inspection          </mat-slide-toggle>        
      </span>
    </span>

    <span>
      <span>
        <mat-slide-toggle floatLabel="always" appearance="none" color="primary"
            formControlName="periodicMaintenance" id="periodicMaintenance" matTooltip="Should weekly or periodic maintenance or inspections occur?"           
            (ngModelChange)="periodicMaintenanceChanging($event)" [(ngModel)]="item.periodicMaintenance"              
            (ngModelChange)="periodicMaintenanceChanged($event)" #periodicMaintenance i18n="@@type.MaintenanceAspect.periodicMaintenance">
Weekly/Periodic Maintenance </mat-slide-toggle>        
      </span>
    </span>

    <span>
      <mat-form-field matTooltip="Weekly/Periodic Maintenance Days" [matTooltipDisabled]="disabledTooltip(this.periodicMaintenanceDays)">
        <mat-label i18n="@@type.MaintenanceAspect.periodicMaintenanceDays">Weekly/Periodic Maintenance Days</mat-label>
        <input matInput formControlName="periodicMaintenanceDays" id="periodicMaintenanceDays"              
            (ngModelChange)="periodicMaintenanceDaysChanging($event)" [(ngModel)]="item.periodicMaintenanceDays"              
            (ngModelChange)="periodicMaintenanceDaysChanged($event)" #periodicMaintenanceDays              
            type="number" placeholder="Weekly/Periodic Maintenance Days" min="0">
      </mat-form-field>
    </span>

    <span>
      <span>
        <mat-slide-toggle floatLabel="always" appearance="none" color="primary"
            formControlName="routineMaintenance" id="routineMaintenance"              
            (ngModelChange)="routineMaintenanceChanging($event)" [(ngModel)]="item.routineMaintenance"              
            (ngModelChange)="routineMaintenanceChanged($event)" #routineMaintenance i18n="@@type.MaintenanceAspect.routineMaintenance">
Routine Maintenance          </mat-slide-toggle>        
      </span>
    </span>

  
    <span>
      <mat-form-field matTooltip="Routine Maintenance Days" [matTooltipDisabled]="disabledTooltip(this.routineMaintenanceDays)">
        <mat-label i18n="@@type.MaintenanceAspect.routineMaintenanceDays">Routine Maintenance Days</mat-label>
        <input matInput formControlName="routineMaintenanceDays" id="routineMaintenanceDays"              
            (ngModelChange)="routineMaintenanceDaysChanging($event)" [(ngModel)]="item.routineMaintenanceDays"              
            (ngModelChange)="routineMaintenanceDaysChanged($event)" #routineMaintenanceDays              
            type="number" placeholder="Routine Maintenance Days" min="0">
      </mat-form-field>
    </span>

  </div>
  <div class="crud-item-section">
    <span>
      <mat-form-field matTooltip="Latest Routine Maintenance Date" [matTooltipDisabled]="disabledTooltip(this.latestRoutineMaintenanceDate)" class="crud-item-input-medium">
        <mat-label i18n="@@type.Asset.latestRoutineMaintenanceDate">Latest Routine Maintenance Date</mat-label>
        <input matInput formControlName="latestRoutineMaintenanceDate" id="latestRoutineMaintenanceDate"              
            [ngModel]="asset.latestRoutineMaintenanceDate" #latestRoutineMaintenanceDate              
            [matDatepicker]="latestRoutineMaintenanceDateDatePicker" placeholder="Latest Routine Maintenance Date"              
            disabled>
        <mat-datepicker-toggle matSuffix [for]="latestRoutineMaintenanceDateDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #latestRoutineMaintenanceDateDatePicker color="primary"></mat-datepicker>
      </mat-form-field>
    </span>

    <span>
      <mat-form-field matTooltip="Next Routine Maintenance Required Date" [matTooltipDisabled]="disabledTooltip(this.nextRoutineMaintenanceRequiredDate)" class="crud-item-input-medium">
        <mat-label i18n="@@type.Asset.nextRoutineMaintenanceRequiredDate">Next Routine Maintenance Required Date</mat-label>
        <input matInput formControlName="nextRoutineMaintenanceRequiredDate" id="nextRoutineMaintenanceRequiredDate"              
            [ngModel]="asset.nextRoutineMaintenanceRequiredDate" #nextRoutineMaintenanceRequiredDate              
            [matDatepicker]="nextRoutineMaintenanceRequiredDateDatePicker" placeholder="Next Routine Maintenance Required Date"              
            disabled>
        <mat-datepicker-toggle matSuffix [for]="nextRoutineMaintenanceRequiredDateDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #nextRoutineMaintenanceRequiredDateDatePicker color="primary"></mat-datepicker>
      </mat-form-field>
    </span>

    <span class="crud-editor-warning" *ngIf="!createMode && asset?.latestRoutineMaintenanceDate == null">No maintenance has been performed on this asset yet.</span>
  </div>

</form>